import React , { useState , useEffect} from "react";
import { Navbar, Image, Badge, div, ListGroup } from 'react-bootstrap';



const Exam_List = (props) => {;

    function x(a,b,i){
var flag=0;
        a.forEach((value ,j)=> {
            if(value.Exam_Date._i===b.Exam_Date._i && i!==j) 
            flag=1;
    
         });

         return flag
     
    
    
       } 
    return (
        <div class={props.Course_Exams.length > 0 ? "visible" : 'invisible'}>
               <div class={props.count > 0 ? "visible" : 'invisible'}><ListGroup.Item variant="danger" >!!!קיימת חפיפה בין הבחינות נא לשים לב </ListGroup.Item></div>
       <ListGroup.Item >לוח מבחנים</ListGroup.Item> 
          
             
 

                        



            <ListGroup>
       
                {props.Course_Exams.map((item,i) => (
                    <ListGroup.Item variant={x(props.Course_Exams,item,i)=== 0 ? "success" : 'warning'}>{item.coursename}  {item.Exam_Date._i}  </ListGroup.Item>
                ))}
  
            </ListGroup>
        </div >
    );
}
export default Exam_List;